import { Component } from '@angular/core';
import { PluginsService } from './sofbox/plugins.service';
import { Router, NavigationEnd} from "@angular/router";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private plugins: PluginsService, private router: Router) { }

  title = 'talk.memd';
  /*
  //catch non-param hits
  +        if (res.length === 4 || res.length === 7) {
  +            window.location.href = 'https://patient.memd.me';
  +        }
           //handle unbounce.com created url
  +        else if (res[3] !== '#') {
               var res1 = str.substring(0, 10);
               window.location.href = url;
           }

  */

  ngOnInit() {
    let parsedUrl = new URL(window.location.href);
    let res = parsedUrl.toString().split("/");
    var str = res[3];
    /*
    //catch non-param hits
    if(res.length===4){
      //console.log('members only');
      if(res[4]!=='members'){
        window.location.href='https://patient.memd.me';
      }
    }
    else if(res.length===7){
      //console.log('claim or activate or params');
      //console.log('action='+res[6])
      if(res[6]=='claim'||res[6]=='activate'||res[6].toString().startsWith('?')){
        //noop
      }
      else{
        window.location.href='https://patient.memd.me';
      }
    }
    else if(res.length===8){
      //console.log('activate');
      //console.log('action='+res[6])
      if(res[6]!=='activate'){
        window.location.href='https://patient.memd.me';
      }
    }
    //handle unbounce.com created url, reorganize structure
    //https://talk.memd.me/?aic=1N1Q1&pers=1123354#/members/4e8663a4-f67c-4e4e-aee9-f92e0ee3bc7c
    else if(res[3]!=='#'){
      let url = parsedUrl.origin+'/#/'+res[4]+'/'+res[5]+res[3].toString().slice(0, -1);
      window.location.href = url;
    }
    */
  }
}
